import { useEffect } from "react";

import {
  MESSENGER_GROUP_INVITE_EVENT,
  type MessengerGroupInviteDetail,
} from "../utils/groupInvite";

export function useGroupInviteLinkListener(
  onInvite: (token: string) => void,
  enabled = true,
) {
  useEffect(() => {
    if (!enabled) return;

    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<MessengerGroupInviteDetail>;
      const token = customEvent.detail?.token;
      if (!token) return;

      event.preventDefault();
      onInvite(token);
    };

    window.addEventListener(MESSENGER_GROUP_INVITE_EVENT, handler);
    return () =>
      window.removeEventListener(MESSENGER_GROUP_INVITE_EVENT, handler);
  }, [enabled, onInvite]);
}
